import { render, staticRenderFns } from "./TemplateInfoHead.vue?vue&type=template&id=3ac7affa&scoped=true"
import script from "./TemplateInfoHead.vue?vue&type=script&lang=js"
export * from "./TemplateInfoHead.vue?vue&type=script&lang=js"
import style0 from "./TemplateInfoHead.vue?vue&type=style&index=0&id=3ac7affa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7affa",
  null
  
)

export default component.exports